export const HERO_STAGE_MOBILE_MAX_WIDTH_PX = 767;
export const HERO_STAGE_MOBILE_MEDIA = `(max-width:${HERO_STAGE_MOBILE_MAX_WIDTH_PX}px)`;
export const HERO_STAGE_DESKTOP_MEDIA = `(min-width:${HERO_STAGE_MOBILE_MAX_WIDTH_PX + 1}px)`;
